import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/interfaces/stores/RootState';
import { Auditing } from '@/interfaces/models/Auditing';
import AuditingApiService from '@/api/http/AuditingApiService';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import { Page } from '@/interfaces/api/Page';
import { AxiosResponse } from 'axios';

interface AuditingState {
  items: Auditing[];
  filter: Filter;
  pagination: {
    total: number;
  };
}

const api: AuditingApiService = new AuditingApiService();

const state: AuditingState = {
  items: [],
  filter: {},
  pagination: {
    total: 10,
  },
};

const actions: ActionTree<AuditingState, RootState> = {
  fetch({ commit, state }, data: { page: Page }) {
    return api.getAudits(data.page, state.filter).then((res: AxiosResponse<Auditing[] | Pagination<Auditing>>) => {
      commit('setItems', res.data);
    });
  },
  setFilter({ commit }, filter: Filter) {
    commit('setFilter', filter);
  },
};

const mutations: MutationTree<AuditingState> = {
  setItems(state: AuditingState, data: Pagination<Auditing>) {
    state.items = (data.data as Auditing[]) || data;
    state.pagination.total = data?.total || 0;
  },
  setFilter(state: AuditingState, data: Filter) {
    state.filter = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
